import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type { UpdateSlackChannel, UpdateSlackChannels } from "../types"

export const slackChannelsMutators = {
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateSlackChannel }) => {
			await tx.mutate.slackChannels.update({
				id: args.id,
				inbox: args.inbox,
				changelog: args.changelog,
				type: args.type,
				groupingWindowMinutes: args.groupingWindowMinutes,
				tagId: args.tagId,
				assigneeId: args.assigneeId,
				updatedAt: Date.now(),
			})
		},
	),
	/** "Set all" on a group of the Channels page. */
	updateMany: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateSlackChannels }) => {
			const updatedAt = Date.now()
			for (const id of args.ids) {
				await tx.mutate.slackChannels.update({
					id,
					inbox: args.inbox,
					changelog: args.changelog,
					updatedAt,
				})
			}
		},
	),
}
